import jsPDF from "jspdf"
import moment from "moment"

var image = require("@/assets/logoBlue.png") //logo on top
import { arabicFont } from "@/bookings/methods/pdfFont"

var pageWidth = 210
var pageHeight = 297
var doc
var start
var end
var lineHeight
var currentY
var normalFontSize = 16
// var mediumFontSize = 14
var smallFontSize = 10

const resetValues = () => {
  start = 10
  end = 200
  lineHeight = Math.floor(normalFontSize / 2)
  currentY = 2 * lineHeight - 10
}

export const printInvoice = (booking) => {
    doc = new jsPDF("p", "mm", [pageWidth, pageHeight])
    doc.addFileToVFS("Amiri-Regular-normal.ttf", arabicFont)
    doc.addFont("Amiri-Regular-normal.ttf", "Amiri-Regular", "normal")
    resetValues()
    doc.addImage(image, "jpeg", 85, currentY - 1, 50, 15)
    doc.setFontSize(smallFontSize)
    
    // let landlordDetailsEn = [
    //   `${booking.property.landlord.user.firstName} ${booking.property.landlord.user.lastName}`,
    //   `Phone: ${booking.property.landlord.contactNumber}`
    // ]
    // landlordDetailsEn.map((item, index) => {
    //   doc.text(item, start, currentY + (lineHeight - 2) * (index + 1))
    // })
    
    nextLine(4)
    doc.text(`Date :${moment().format("DD/MMMM/YYYY")} `, start, currentY)
    setArabicFont()
    moment.locale("ar_SA")
    doc.text(`التاريخ : ${moment().format("DD/MMMM/YYYY")}`, end, currentY, {
      align: "right",
    })
    moment.locale('en')
    fontType("medium")
    nextLine(1)
    doc.text(`Booking Ref.No: ${booking.bookingReferenceId}`, start, currentY)
    setArabicFont()
    doc.text(
      ` ${booking.bookingReferenceId}:فاتورة ضريبية رقم `,
      end,
      currentY,
      {
        align: "right",
      }
    )
    fontType("medium")
    nextLine(2)
    const landlordDetails = [
        `Name: ${booking.property.landlord.user.firstName} ${booking.property.landlord.user.lastName}`,
        `Mobile No: ${booking.property.landlord.contactNumber}`,
        `Email: ${booking.property.landlord.user.email}`
    ]
    landlordDetails.map((landlordText) => {
        doc.text(
          landlordText,
          start,
          currentY
        )
        nextLine(0.8)
    })
    // printing landlord details
    let tableValues = [
        {
            titleEn: "Landlord Name",
            titleAr: "اسم المالك",
            valueEn: `${booking.property.landlord.user.firstName} ${booking.property.landlord.user.lastName}`,
            x: start + 5 
        },
        {
            titleEn: "Property Name",
            titleAr: "اسم الخاصية",
            valueEn: booking.property.nameEn,
            valueAr: booking.property.nameAr,
            x: start + 35
          },
        {
            titleEn: "Phone",
            titleAr: "هاتف",
            valueEn: `${booking.property.landlord.contactNumber}`,
            x: start + 65
        },
        {
            titleEn: "Total Paid Amount",
            titleAr: "إجمالي المبلغ المدفوع",
            valueEn: `${booking.price} ${booking.currency}`,
            x: start + 90
        },
        {
            titleEn: "Total Commision",
            titleAr: "إجمالي العمولة",
            valueEn: `${(booking.price - booking.priceToLandlord).toFixed(2)} ${booking.currency}`,
            x: start + 125
        }
    ]
    doc.setFillColor(189, 189, 189)
    doc.rect(start, currentY, end - start, 10, "F")
    nextLine(0.4)
    tableValues.forEach((tableField) => {
        doc.text(tableField.titleEn, tableField.x, currentY)
        setArabicFont()
        doc.text(`(${tableField.titleAr})`, tableField.x, currentY + 4)
        fontType('medium')
        doc.text(tableField.valueEn, tableField.x, currentY + 11)
        if (tableField.valueAr){
            doc.text(`(${tableField.valueAr})`, tableField.x, currentY + 16)
        }
    })
    nextLine(2.3)
    seperator()
    return doc.save(`PayAtProperty-Invoice-${booking.bookingReferenceId}`)
}
const setArabicFont = () => doc.setFont("Amiri-Regular")
const fontType = (type) => doc.setFont(undefined, type)
const nextLine = (numberOfLines) => (currentY += numberOfLines * lineHeight + 1)
const seperator = () => {
  doc.setDrawColor(210, 210, 210)
  doc.line(start, currentY, end, currentY)
}
